var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var Twitter24 = function Twitter24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.075 5.13a9.073 9.073 0 0 1-2.61.716 4.552 4.552 0 0 0 1.998-2.514c-.878.52-1.85.9-2.886 1.103A4.536 4.536 0 0 0 16.26 3c-2.934 0-5.09 2.737-4.427 5.579a12.9 12.9 0 0 1-9.366-4.747 4.55 4.55 0 0 0 1.406 6.067 4.525 4.525 0 0 1-2.057-.569c-.05 2.105 1.459 4.075 3.644 4.513-.64.174-1.34.214-2.052.078a4.548 4.548 0 0 0 4.245 3.155 9.137 9.137 0 0 1-6.728 1.883A12.864 12.864 0 0 0 7.891 21c8.437 0 13.204-7.126 12.916-13.517a9.252 9.252 0 0 0 2.268-2.352z",
    fill: "currentColor"
  }));
};

Twitter24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '24': Twitter24
};
export var Twitter = function Twitter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['24'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'Twitter' icon. Please use one of the available sizes: '24'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};